import { SvgIcon } from '../../icons/SvgIcon';
import * as React from 'react';

interface IProps {
	tintColor?: string;
	className?: string;
}

export const QuickBooksOnlineIntegrationGraphic: React.FC<IProps> = props => {
	const { className, tintColor = '#2ca01c26' } = props;

	return (
		<SvgIcon className={`integration-icon ${className}`} fill='none' height={141} width={219}>
			<circle cx='60.5' cy='52.5' r='52.5' fill={tintColor} />
			<circle cx='171' cy='70' r='48' fill={tintColor} />
			{/* QuickBooks logo and graphics */}
			<g transform='translate(25, 30)'>
				{/* QuickBooks circle background */}
				<circle cx='35' cy='35' r='30' fill='#2CA01C' />
				{/* QB text */}
				<text
					x='35'
					y='42'
					textAnchor='middle'
					fill='white'
					fontSize='20'
					fontWeight='bold'
					fontFamily='Arial, sans-serif'
				>
					QB
				</text>
			</g>
			{/* Connection line */}
			<path d='M85 65 Q120 65 155 65' stroke='#2CA01C' strokeWidth='2' strokeDasharray='5,5' fill='none' />
			{/* Charts and graphs representing accounting */}
			<g transform='translate(140, 45)'>
				{/* Bar chart */}
				<rect x='5' y='35' width='8' height='15' fill='#2CA01C' />
				<rect x='15' y='25' width='8' height='25' fill='#2CA01C' />
				<rect x='25' y='30' width='8' height='20' fill='#2CA01C' />
				<rect x='35' y='20' width='8' height='30' fill='#2CA01C' />
				{/* Chart base */}
				<line x1='0' y1='50' x2='48' y2='50' stroke='#393A3D' strokeWidth='2' />
				<line x1='0' y1='10' x2='0' y2='50' stroke='#393A3D' strokeWidth='2' />
			</g>
			{/* Invoice/document icon */}
			<g transform='translate(75, 75)'>
				<rect x='0' y='0' width='30' height='40' fill='white' stroke='#2CA01C' strokeWidth='2' rx='2' />
				<line x1='5' y1='8' x2='25' y2='8' stroke='#393A3D' strokeWidth='1' />
				<line x1='5' y1='14' x2='25' y2='14' stroke='#393A3D' strokeWidth='1' />
				<line x1='5' y1='20' x2='15' y2='20' stroke='#393A3D' strokeWidth='1' />
				<line x1='5' y1='26' x2='20' y2='26' stroke='#393A3D' strokeWidth='1' />
				<line x1='5' y1='32' x2='25' y2='32' stroke='#393A3D' strokeWidth='1' />
			</g>
			{/* Dollar sign in circle */}
			<g transform='translate(155, 85)'>
				<circle cx='15' cy='15' r='12' fill='#2CA01C' />
				<text
					x='15'
					y='20'
					textAnchor='middle'
					fill='white'
					fontSize='14'
					fontWeight='bold'
					fontFamily='Arial, sans-serif'
				>
					$
				</text>
			</g>
			{/* Calculator icon */}
			<g transform='translate(110, 35)'>
				<rect x='0' y='0' width='20' height='25' fill='#393A3D' rx='2' />
				<rect x='2' y='2' width='16' height='6' fill='#E8E8E8' />
				{/* Calculator buttons */}
				<rect x='2' y='10' width='4' height='3' fill='#E8E8E8' />
				<rect x='8' y='10' width='4' height='3' fill='#E8E8E8' />
				<rect x='14' y='10' width='4' height='3' fill='#E8E8E8' />
				<rect x='2' y='15' width='4' height='3' fill='#E8E8E8' />
				<rect x='8' y='15' width='4' height='3' fill='#E8E8E8' />
				<rect x='14' y='15' width='4' height='3' fill='#E8E8E8' />
				<rect x='2' y='20' width='4' height='3' fill='#E8E8E8' />
				<rect x='8' y='20' width='4' height='3' fill='#E8E8E8' />
				<rect x='14' y='20' width='4' height='3' fill='#2CA01C' />
			</g>
			{/* Checkmark for sync status */}
			<g transform='translate(180, 50)'>
				<circle cx='10' cy='10' r='8' fill='#2CA01C' />
				<path
					d='M6 10 L9 13 L14 7'
					stroke='white'
					strokeWidth='2'
					strokeLinecap='round'
					strokeLinejoin='round'
					fill='none'
				/>
			</g>
		</SvgIcon>
	);
};
